module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/img06-915d30f58d6e7c91d10b620635bddf4f.png";